import { apiClient } from './ApiClient'

export interface BlockedSender {
  blockedSenderId: string
  blockType: 'Email' | 'Domain'
  value: string
  notes?: string
  createdAt: string
}

export interface AddBlockedSenderRequest {
  blockType: 'Email' | 'Domain'
  value: string
  notes?: string
}

export class BlockedSendersService {
  private basePath = '/blockedsenders'

  async getBlockedSenders(): Promise<BlockedSender[]> {
    return await apiClient.get<BlockedSender[]>(this.basePath)
  }

  async addBlockedSender(request: AddBlockedSenderRequest): Promise<BlockedSender> {
    return await apiClient.post<BlockedSender>(this.basePath, request)
  }

  async removeBlockedSender(id: string): Promise<void> {
    await apiClient.delete<object>(`${this.basePath}/${id}`)
  }

  async blockSenderFromTicket(ticketId: string, blockDomain: boolean): Promise<void> {
    await apiClient.post(`/tickets/${ticketId}/block-sender`, { blockDomain })
  }
}

export const blockedSendersService = new BlockedSendersService()
